import { Pencil } from 'lucide-react';
import { ReactNode } from 'react';
import { Button } from '../../../../ui/components/ui/button';

export interface CheckoutDataRowProps {
  label: string;
  /** Read-only view of the section. */
  summary: ReactNode;
  isEditing: boolean;
  /** Without it the row is read-only (e.g. the payment method of an invoice offer). */
  onEdit?: () => void;
  /** Collapses the row again – the caller validates the section first. */
  onDone?: () => void;
  /** The inputs shown while editing. */
  children?: ReactNode;
}

/** One section of the checkout data card: summary with a pencil, or the section's inputs while editing. */
const CheckoutDataRow = ({ label, summary, isEditing, onEdit, onDone, children }: CheckoutDataRowProps) => {
  if (isEditing) {
    return (
      <div className="flex flex-col gap-3 px-4 py-3">
        <span className="text-xs text-[#4D4D4D]">{label}</span>
        {children}
        {onDone && (
          <Button type="button" variant="outline" size="sm" className="self-end" onClick={onDone}>
            Übernehmen
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-start gap-4 px-4 py-3">
      <span className="w-16 shrink-0 text-xs text-[#4D4D4D]">{label}</span>
      <div className="min-w-0 flex-1 break-words text-xs font-medium text-[#333333]">{summary}</div>
      {onEdit && (
        <button
          type="button"
          aria-label={`${label} bearbeiten`}
          onClick={onEdit}
          className="shrink-0 text-[#082729]/50 transition-colors hover:text-[#082729]">
          <Pencil className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
};

export default CheckoutDataRow;
